import gsap from 'gsap';

const enterArchive = (container) => {

    // let postItems = document.querySelectorAll('.bg-post-item');
    let postItems = container.querySelectorAll('.bg-post-item');

    const tl = gsap.timeline()

    tl
    .from( postItems, { autoAlpha: 0, y: 20, stagger: .3, ease: "power3.out"})

    return tl
}

export default enterArchive;